//-------------------------------------------------------------------------------------------------- Imports
import { Button, Card, Col, Row, Typography } from "antd";
import { StyleSheet } from "../../StyleSheet";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { RightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { useDispatch, useSelector } from "react-redux";
import { postGenerateInvoice } from "../../methods/Methods";
import { clearAlert, setAlert, showAlert } from "../../stores/slices/alertSlice";
import { AppDispatch } from "../../stores/store";
import { getConfigurableServiceState } from "../../stores/slices/configurableServicesSlice";
const { Text } = Typography;

type NavigationItem = {
    title: string;
    path?: string;
    action?: () => void;
};

//-------------------------------------------------------------------------------------------------- View
const BillingHome = () => {
    const navigate = useNavigate();
    const { selectedContract } = useSelector(getGeneralData);
    const [clientId, setClientId] = useState<string>("");
    const dispatch = useDispatch<AppDispatch>();
    const confService = useSelector(getConfigurableServiceState);
    const canGenerateBilling = confService.dataList.some(
        (service) => service.name.startsWith("DAF_SEND_GENERATE_BILLING") && service.enabled
    );

    useEffect(() => {
        if (selectedContract) {
            setClientId(selectedContract.sucursal + selectedContract.suscriptor);
        }
    }, [selectedContract]);

    const handleFinalizeAlert = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
    }, [dispatch]);

    const handleGenerateInvoice = async () => {
        let message = "";
        let show = false;
        let typeAlert: "INFO" | "SUCCESS" | "ERROR" = "INFO";
        await postGenerateInvoice(clientId)
            .then((response) => {
                if (response.data && response.data.data[0]) {
                    let resp = response.data.data[0];
                    if (resp.status === true) {
                        typeAlert = "SUCCESS";
                    } else {
                        typeAlert = "INFO";
                    }
                    show = true;
                    message = resp.message;
                }
            })
            .catch(() => {
                typeAlert = "ERROR";
                message = "Ha ocurrido un error, intentelo más tarde.";
                show = true;
            });
        dispatch(setAlert({
            show: show,
            title: "¡Estimado Usuario!",
            message: message,
            type: typeAlert,
            onFinalize: handleFinalizeAlert
        }));
    };

    const navigationData: NavigationItem[] = [
        { title: 'Datos de Facturación', path: '/billing/billing-data' },
        { title: 'Descargar Facturas', path: '/billing/download-billing' },
        ...(canGenerateBilling
            ? [{
                title: 'Generar y Enviar Factura',
                action: handleGenerateInvoice,
            }]
            : []
        ),
    ];

    return (
        <>
            <SubDefaultLayout title={"Facturación"} >
                <Row style={styles.rowPrincipal}>
                    <Col xs={16} xl={14} style={{ paddingLeft: 10 }}>
                        {navigationData.map((item, index) => (
                            <Card
                                key={index}
                                style={{ ...styles.cardStyles, cursor: "pointer" }}
                                onClick={() => item.path ? navigate(item.path) : item.action?.()}>
                                <Row align={"middle"}>
                                    <Col xs={18} xl={18}>
                                        <Text style={{ ...styles.textRegular, flex: 1, color: '#797e84', fontWeight: 600 }}>{item.title}</Text>
                                    </Col>
                                    <Col xs={6} xl={6} style={{ display: 'flex', justifyContent: "flex-end" }}>
                                        <Button
                                            icon={<RightOutlined style={{ color: '#797e84' }} />}
                                            type="text" />
                                    </Col>
                                </Row>
                            </Card>
                        ))}
                    </Col>
                </Row>
            </SubDefaultLayout>

        </>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    rowPrincipal: {
        marginTop: 30,
        display: 'flex',
        justifyContent: 'center',
    },
    textRegular: {
        color: "black",
        fontSize: 17,
        fontWeight: 500,
    },
    cardStyles: {
        backgroundColor: "white",
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 20,
    }
});

export default BillingHome;
